/// <reference path="../../../../tools/typings/tsd.d.ts"/>
/// <reference path="../../content.ts"/>

module DealerwareWebContent {
    "use strict";

    export interface ICreateContract {
        customer: any;
        pickupDate: Date;
        minPickupDate: Date;
        pickupTime: string;
        dropoffDate: Date;
        minDropoffDate: Date;
        dropoffTime: string;
        availableTimes: {}[];
        repairOrder: string;
        serviceVehicleId: string;
        serviceAdvisorId: number;

        customerSelected(customer: any) : void;
        reset() : void;
        createContract() : void;
    }

    export class CreateContractController implements ICreateContract {
        public static $inject: string[] = [
            '$q',
            '$filter',
            '$state',
            '$stateParams',
            '$dealerwareNotification',
            '$dealerwareLoading',
            '$mobilityCompanyAuthentication',
            '$dealerwareSolrSearchCustomerCollection',
            '$dealerwareCustomerFactory',
            'DealerwareCustomerModel',
            'DealerwareContractModel',
            '$dealerwareInternationalizationDateFormats'
        ]

        public timeZone: string;
        public repairOrder: string;
        public serviceVehicleId: string;
        public serviceAdvisorId: number;
        public dateInternationalizationFormat = {};

        private _customer: any;
        private _pickupDate: Date;
        private _minPickupDate: Date;
        private _pickupTime: string;
        private _dropoffDate: Date;
        private _dropoffTime: string;
        private _availableTimes: {}[];
        private _nextTimeSlot: string

        public locale: any  = this.$dealerwareInternationalizationDateFormats.datePickerFormat();


        constructor(public $q: any,
                    public $filter: any,
                    public $state: any,
                    public $stateParams: any,
                    public $dealerwareNotification: any,
                    public $dealerwareLoading: any,
                    public $auth: any,
                    public solrSearch: any,
                    public customerFactory: any,
                    public customerModel: any,
                    public contractModel: any,
                    public $dealerwareInternationalizationDateFormats: any) {
            this.setTimeZoneAndDefaultContractTimes();

            if (this.$stateParams.customerId) {
                this.customerFactory.loadCustomer(this.$auth.location.id, this.$stateParams.customerId).then(
                    (response: any) => { this.customerSelected(response.customer.accountSettings); },
                    (response: any) => { this.$dealerwareNotification.apiError(response); }
                );
            }
        }

        public get customer() : any {
            return this._customer;
        }

        public set customer(customer: any) {
            this._customer = this.customerFactory.convertToInstance(customer);
        }

        public get pickupDate() : Date {
            if (!this._pickupDate) {
                this._pickupDate = this.timeZonedDate(
                    this.nowWithTimeZone().startOf('hour')
                );
            }

            return this._pickupDate;
        }

        public set pickupDate(pickupDate: Date) {
            this._pickupDate = pickupDate;
            if (this._pickupDate > this._dropoffDate) {
                this.dropoffDate = this.timeZonedDate(
                    this.momentWithTimezone(moment(pickupDate)).startOf('hour').add(2, 'days')
                );
            }
        }

        public get minPickupDate() : Date {
            if (!this._minPickupDate) {
                this._minPickupDate = this.timeZonedDate(
                    this.nowWithTimeZone()
                )
            }

            return this._minPickupDate;
        }

        public get pickupTime() : string {
            if (!this._pickupTime) {
                this._pickupTime = this.nextTimeSlot;
            }

            return this._pickupTime;
        }

        public set pickupTime(pickupTime: string) {
            this._pickupTime = pickupTime;
        }

        public get dropoffDate() : Date {
            if (!this._dropoffDate) {
                this._dropoffDate = this.timeZonedDate(
                    this.nowWithTimeZone().startOf('hour').add(2, 'days')
                );
            }

            return this._dropoffDate;
        }

        public set dropoffDate(dropoffDate: Date) {
            this._dropoffDate = dropoffDate;
        }

        public get minDropoffDate() : Date {
            return this.pickupDate;
        }

        public get dropoffTime() : string {
            if (!this._dropoffTime) {
                this._dropoffTime = this.nextTimeSlot;
            }

            return this._dropoffTime;
        }

        public set dropoffTime(dropoffTime: string) {
            this._dropoffTime = dropoffTime;
        }

        public get availableTimes() : {}[] {
            if (!this._availableTimes) {
                this._availableTimes = this.$dealerwareInternationalizationDateFormats.getAvailablesTimesFormat();
            }

            return this._availableTimes;
        }

        private nowWithTimeZone () : moment.Moment {
            return this.momentWithTimezone(moment());
        }

        private momentWithTimezone (thisMoment: moment.Moment) : moment.Moment {
            return thisMoment.tz(this.timeZone || moment.tz.guess())
        }

        private setTimeZoneAndDefaultContractTimes() : void {
            // formatTimeSimple assumes UTC if a timeZone isn't given, but make it explicit here.
            //
            this.timeZone = this.$auth.location.time_zone_name || 'UTC';

            // getter is also a setter.
            //
            this.nextTimeSlot;
        }

        private timeZonedDate (momentTimeZone: moment.Moment) : Date {
            return new Date(
                parseInt(momentTimeZone.format('YYYY')),
                this.$filter('zeropad')(momentTimeZone.month()),
                parseInt(momentTimeZone.format('DD'))
            )
        }

        private get nextTimeSlot() : string {
            if (this.timeZone) {
                var now             = this.nowWithTimeZone().startOf('minute');
                var offsetMoment    = now.add(30 - now.minute() % 30, 'minutes');
                var offsetTime      = offsetMoment.format('HH:mm');

                this._nextTimeSlot = offsetTime;
                this.pickupTime = this._nextTimeSlot;
                this.dropoffTime = this._nextTimeSlot;

                this.pickupDate;
                this.dropoffDate;
                this.minPickupDate;
            }

            if (!this._nextTimeSlot) {
                var now = this.nowWithTimeZone().startOf('minute');
                this._nextTimeSlot = now.add(30 - now.minute() % 30, 'minutes').format('HH:mm');
            }

            return this._nextTimeSlot;
        }

        public customerSelected(customer: any) : void {
            if (customer.data.insurance_preferences) {
                this.customer = customer;
            } else {
                this.customerFactory.loadCustomer(this.$auth.location.id, customer.data.id).then(
                    (response: any) => { this.customer = response.customer.accountSettings },
                    (response: any) => { this.$dealerwareNotification.apiError(response); }
                );
            }
        }

        public isValid() : boolean {
            return this.pickupDate.getTime() < this.dropoffDate.getTime() || (
                this.pickupDate.getTime() === this.dropoffDate.getTime() &&
                this.pickupTime < this.dropoffTime
            );
        }

        public reset() : void {
            this.solrSearch.clear();
            this.customer = undefined;
            this.pickupDate = undefined;
            this.pickupTime = undefined;
            this.dropoffDate = undefined;
            this.dropoffTime = undefined;
            this.repairOrder = undefined;
            this.serviceVehicleId = undefined;
            this.serviceAdvisorId = undefined;
        }

        public createContract() : void {
            var _self = this,
                contract = new this.contractModel({
                    local_pickup_date: moment(this.pickupDate).format('YYYY-MM-DD'),
                    local_pickup_time: this.$filter('date')(this.pickupTime, 'h:mm a', 'GMT'),
                    local_dropoff_date: moment(this.dropoffDate).format('YYYY-MM-DD'),
                    local_dropoff_time: this.$filter('date')(this.dropoffTime, 'h:mm a', 'GMT'),
                    pickup_location_id: this.$auth.location.id,
                    dropoff_location_id: this.$auth.location.id,
                    email: this.customer.accountSettings.data.email,
                    customer_id: this.customer.accountSettings.data.id,
                    reservation_insurances_attributes: this.customer.accountSettings.data.insurance_preferences,
                    ro_number: this.repairOrder,
                    service_vehicle_id: this.serviceVehicleId,
                    service_advisor_id: this.serviceAdvisorId
                });

            var loader = this.$dealerwareLoading.show('The contract is being created...');
            contract.$create({
                promise: true,
                params: { location_id: this.$auth.location.id }
            }).then(
                (response: any) => {
                    _self.$state.go('shortcuts.contractConfirmation', { contractId: response.data.id });
                },
                (response: any) => {
                    _self.$dealerwareNotification.apiError(response);
                }
            ).finally(
                () => { loader.close(); }
            );
        }
    }

    getDealerwareWebContentModule().controller('CreateContractController', CreateContractController);
}
